const getChatbotMessage = (step, t, msgKey = "chatbotMessage") => {
  const isFirst = step.order === 1;
  const showInterviewText = step.type !== "chat-message";

  if (step.type === "test-gh" || step.type === "test") {
    return `${t(
      `opportunity:process.${
        isFirst ? "chatbotIntroFirst" : "chatbotIntroNext"
      }`
    )} ${t(`opportunity:process.stepTypes.test.chatbotStart`)} ${t(
      `opportunity:process.stepTypes.test.${msgKey}`
    )}`;
  }

  if (step.type === "document_upload") {
    return `${t(
      `opportunity:process.${
        isFirst ? "chatbotIntroFirst" : "chatbotIntroNext"
      }`
    )} ${t(
      `opportunity:process.stepTypes.document_upload.${msgKey}`
    )}`;
  }

  return `${t(
    `opportunity:process.${isFirst ? "chatbotIntroFirst" : "chatbotIntroNext"}`
  )}${
    showInterviewText
      ? ` ${t(
          `opportunity:process.${
            isFirst ? "chatbotInterviewFirst" : "chatbotInterviewNext"
          }`
        )} ${t(`opportunity:process.stepTypes.${step.type}.${msgKey}`)}`
      : ""
  }`;
};

export default getChatbotMessage;
